import {
  Typography,
  Avatar,
  List,
  ListItemAvatar,
  ListItemText,
  ListItem,
  Paper,
  makeStyles,
} from "@material-ui/core";
import React from "react";
import { useHistory, useLocation } from "react-router-dom";
import { UserType } from "../services/domain/User";
import { UsersState } from "../redux/state";
import { UserRoleText } from "../services/domain/userRole";

const USER_SEARCH_STATE_KEY = "usersSearch";

const useStyles = makeStyles((theme) => ({
  inactive: {
    ...theme.list.itemDisabled,
  },
  active: {
    ...theme.list.itemPrimary,
  },
}));

export const UsersList: React.FC<{ usersState: UsersState }> = ({
  usersState,
}) => {
  const classes = useStyles();

  const { response } = usersState;
  const history = useHistory();
  const { pathname, search } = useLocation();
  const navigate = (id: string) =>
    history.push(`${pathname}/${id}`, { [USER_SEARCH_STATE_KEY]: search });

  return (
    <Paper>
      <List disablePadding>
        {response.data.map((item, index) => (
          <React.Fragment key={item.id}>
            <ListItem
              button
              alignItems="flex-start"
              onClick={() => navigate(item.upn)}
              divider
              className={item.active ? classes.active : classes.inactive}
              data-test="user-row"
            >
              <ListItemAvatar>
                <Avatar />
              </ListItemAvatar>
              <ListItemText
                primary={
                  <span>
                    {`${item.fullName || item.loginEmail} ${
                      item.active ? "" : "(inactive)" // ao users will never see this
                    }`}
                  </span>
                }
                secondary={
                  <React.Fragment>
                    <Typography
                      component="span"
                      variant="subtitle1"
                      color="textPrimary"
                    >
                      {item.userType === UserType.Ofqual && "Ofqual"}
                      {item.userType === UserType.CCEA && "CCEA Regulation"}
                      {item.userType === UserType.AO &&
                        `Awarding organisation: ${item?.awardingOrg?.name}`}

                      {item.userTeams && item.userTeams.length
                        ? ` - ${item.userTeams
                            .map((team) => team.name)
                            .join(", ")}`
                        : ""}
                    </Typography>
                    <br />
                    <Typography
                      component="span"
                      variant="subtitle2"
                      color="textPrimary"
                    >
                      User Role(s):{" "}
                      {item.userRoles
                        .map((userRole) => UserRoleText[parseInt(userRole, 10)])
                        .join(", ")}
                    </Typography>
                  </React.Fragment>
                }
              />
            </ListItem>
          </React.Fragment>
        ))}
      </List>
    </Paper>
  );
};
